module.exports = __webpack_public_path__ + "static/media/icon_plus.274825b8.svg";